import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFetchStockTable } from '../../Redux/features/Stock/stockSlice.js';
import { COMPRESSED_IMAGE_URL } from '../../config/config';
import no_product from '../images/no_product.png';
import ProductDetailV2 from '../../UI/productDetailV2.jsx';
import FilterSectionStoke from '../Admin/AdminPages/FilterSectionForStoke.jsx';
import Footer from '../Footer/Footer.jsx';
import { ToastContainer } from 'react-toastify';
import { MdImageNotSupported } from 'react-icons/md';

// Skeleton Loader Component
const SkeletonLoader = () => {
	return (
		<div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
			{[...Array(8)].map((_, index) => (
				<div key={index} className='w-[370px] h-[450px] mb-14 bg-gray-300 animate-pulse rounded-xl'>
					<div className='w-full h-[300px] bg-gray-400'></div>
					<p className='h-6 w-32 mt-4 bg-gray-400'></p>
					<div className='flex gap-3 mt-2'>
						<p className='h-4 w-20 bg-gray-400'></p>
						<p className='h-4 w-28 bg-gray-400'></p>
					</div>
				</div>
			))}
		</div>
	);
};

const Home = () => {
	const [showModal, setShowModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [stocks, setStocks] = useState([]);
	const [Filter, setFilter] = useState({
		ProductId: 0,
		SubCategory: '',
		Category: '',
		IsDisplayOnPortal: 1,
	});

	const dispatch = useDispatch();
	const { userStock, totalPages } = useSelector((state) => state.stock);
	const currentPage = useRef(1);

	// const fetchPageData = useCallback(async () => {
	// 	setIsLoading(true);
	// 	await dispatch(getFetchStockTable({ page: currentPage.current, data: Filter }));

	// 	setIsLoading(false);
	// }, [dispatch, Filter]);

	// useEffect(() => {
	// 	// Initially load data for the first page
	// 	if (userStock[currentPage.current]?.length === 0 || !userStock[currentPage.current]) {
	// 		fetchPageData();
	// 	}
	// }, [userStock, fetchPageData]);

	// // Handle data when userStock is updated (i.e., when the next page is fetched)
	// useEffect(() => {
	// 	let allStocks = [];
	// 	Object.values(userStock).forEach((page) => {
	// 		allStocks = [...allStocks, ...page];
	// 	});

	// 	// Remove duplicates by ArticleCode
	// 	const uniqueStocks = Array.from(
	// 		new Map(allStocks.map((item) => [item.ArticleCode, item])).values()
	// 	);

	// 	setStocks(uniqueStocks);
	// }, [userStock]);

	// // Memoize handleScroll to avoid unnecessary re-renders
	// const handleScroll = useCallback(() => {
	// 	const scrollHeight = document.documentElement.scrollHeight;
	// 	const scrollTop = document.documentElement.scrollTop;
	// 	const clientHeight = window.innerHeight;

	// 	// When user reaches the bottom, fetch next page
	// 	if (
	// 		!isLoading &&
	// 		scrollHeight - scrollTop <= clientHeight + 1 &&
	// 		currentPage.current < totalPages
	// 	) {
	// 		currentPage.current += 1;
	// 		fetchPageData();
	// 	}
	// }, [isLoading, totalPages, fetchPageData]);

	// // Attach scroll event listener
	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll);
	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [handleScroll]);

	// // Open modal for product detail
	// const openModal = (item) => {
	// 	setSelectedProduct(item);
	// 	setShowModal(true);
	// };

	// // Close modal
	// const closeModal = () => {
	// 	setShowModal(false);
	// 	setSelectedProduct(null);
	// };

	// // Reset filter
	// const handleReset = () => {
	// 	setFilter({
	// 		ProductId: 0,
	// 		SubCategory: '',
	// 		Category: '',
	// 		IsDisplayOnPortal: '',
	// 	});
	// 	dispatch(getFetchStockTable({ page: 1, data: Filter }));
	// };

	// // Handle stock filter
	// const handleStokeFilter = () => {
	// 	dispatch(getFetchStockTable({ page: 1, data: Filter })).then((resp) => {
	// 		setStocks(resp?.payload?.stock?.allStock);
	// 	});
	// };

	const fetchPageData = async () => {
		if (isLoading) return; // Prevent duplicate calls
		setIsLoading(true);

		await dispatch(getFetchStockTable({ page: currentPage.current, data: Filter }));

		setIsLoading(false);
	};

	// Initial data load
	useEffect(() => {
		if (!userStock[currentPage.current]) {
			fetchPageData();
		}
	}, []); // Runs only on mount

	// Update stocks when userStock changes
	useEffect(() => {
		setStocks((prevStocks) => {
			let allStocks = [...prevStocks];

			Object.values(userStock).forEach((page) => {
				allStocks = [...allStocks, ...page];
			});

			// Remove duplicates by ArticleCode
			return Array.from(new Map(allStocks.map((item) => [item.ArticleCode, item])).values());
		});
	}, [userStock]);

	// Infinite scrolling handler
	const handleScroll = () => {
		const scrollHeight = document.documentElement.scrollHeight;
		const scrollTop = document.documentElement.scrollTop;
		const clientHeight = window.innerHeight;

		if (
			!isLoading &&
			scrollHeight - scrollTop <= clientHeight + 1 &&
			currentPage.current < totalPages
		) {
			currentPage.current += 1;
			fetchPageData();
		}
	};

	// Attach and remove scroll event
	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [isLoading, totalPages]);

	// Open product modal
	const openModal = (item) => {
		setSelectedProduct(item);
		setShowModal(true);
	};

	// Close modal
	const closeModal = () => {
		setShowModal(false);
		setSelectedProduct(null);
	};

	// Reset filter
	const handleReset = () => {
		const defaultFilter = {
			ProductId: 0,
			SubCategory: '',
			Category: '',
			IsDisplayOnPortal: 1,
		};

		setFilter(defaultFilter);

		// Wait for the state to update before dispatching
		setTimeout(() => {
			dispatch(getFetchStockTable({ page: 1, data: defaultFilter }));
		}, 0);
	};

	// Handle stock filter
	const handleStokeFilter = () => {
		dispatch(getFetchStockTable({ page: 1, data: Filter })).then((resp) => {
			setStocks(resp?.payload?.stock?.allStock);
		});
	};

	return (
		<>
			<div className='py-4 lg:px-32 '>
				<div className=' flex justify-center items-center '>
					<FilterSectionStoke
						Filter={Filter}
						setFilter={setFilter}
						handleStokeFilter={handleStokeFilter}
						handleReset={handleReset}
					/>
				</div>

				{stocks.length === 0 ? (
					<div className='flex flex-col justify-center items-center'>
						<img
							src={no_product}
							alt='No products available'
							className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
						/>
					</div>
				) : (
					<div className='md:mb-36 mb-10 max-[455px]:px-10 flex flex-wrap gap-10 justify-center items-center'>
						{stocks.map((item) => (
							<div
								key={item?.ArticleCode}
								className='w-[370px] h-[450px] mb-14 max-[46px]:w-full max-[460px]:h-[450px]'>
								<div className='overflow-hidden w-full h-full rounded-xl'>
									<div className='relative overflow-hidden w-full h-full rounded-xl object-cover transition-transform duration-500 ease-in-out transform hover:scale-105'>
										<div className='min-[768px]:hidden z-10 flex justify-center items-center'>
											<button
												onClick={() => openModal(item)}
												className='absolute bottom-0 z-10 p-4 mb-8 flex justify-center items-center bg-white border-red-500 border-[2px] rounded-full w-44 h-10 uppercase text-sm font-semibold'>
												Product Detail
											</button>
										</div>
										{!item?.ParentImagePath ? (
											<div className=' w-full h-full flex flex-col justify-center items-center text-red-500 opacity-75 bg-black bg-opacity-10'>
												<MdImageNotSupported className=' text-7xl ' />
												<p className=' text-sm font-medium'>No Image Available</p>
											</div>
										) : (
											<img
												src={`${COMPRESSED_IMAGE_URL}/${item?.ParentImagePath}`}
												alt={`Product ${item?.ProductName}`}
												className='w-full h-full object-cover transition-transform duration-500 ease-in-out transform hover:scale-105'
											/>
										)}

										<div className='max-md:hidden absolute inset-0 flex items-end justify-center text-black opacity-0 transition-opacity duration-700 ease-in-out hover:opacity-100'>
											<button
												onClick={() => openModal(item)}
												className='p-4 mb-8 font-medium flex justify-center items-center bg-white border-red-500 border-[3px] rounded-full w-56 h-14 uppercase transition-transform duration-300'>
												Product Detail
											</button>
										</div>
									</div>
								</div>
								<p className='md:text-xl text-lg mt-2'>{item?.ProductName}</p>
								<div className='flex flex-row gap-3 md:text-lg text-sm max-[400px]:text-xs font-semibold'>
									<p className='text-red-400'>Stock Quantity: {item?.AllStockQty}</p>
								</div>
							</div>
						))}
					</div>
				)}

				{/* Loader for infinite scroll */}
				{isLoading && (
					<div className='flex justify-center items-center mt-4'>
						<SkeletonLoader />
					</div>
				)}

				{/* Modal for product details */}
				{showModal && selectedProduct && (
					<div className='fixed inset-0 bg-black bg-opacity-80 z-50'>
						<div className='flex justify-center items-center h-screen'>
							{/* <ProductDetail ArticleCode={selectedProduct.ArticleCode} closeModal={closeModal} /> */}
							<ProductDetailV2
								ArticleCode={selectedProduct?.ArticleCode}
								Description={selectedProduct?.Description}
								ProductName={selectedProduct?.ProductName}
								ProductId={selectedProduct?.ProductId}
								AllStock={selectedProduct?.AllStockQty}
								ParentImagePath={selectedProduct?.ParentImagePath}
								Category={selectedProduct?.Category}
								CategoryId={selectedProduct?.CategoryId}
								SubCategory={selectedProduct?.SubCategory}
								SubCategoryId={selectedProduct?.SubCategoryId}
								Rating={selectedProduct?.Rating}
								closeModal={closeModal}
							/>
						</div>
					</div>
				)}
				<ToastContainer
					position='top-right'
					autoClose={1000}
					hideProgressBar={true}
					closeOnClick
					pauseOnHover
					draggable
					pauseOnFocusLoss
					className='mt-10'
				/>
			</div>
			<Footer />
		</>
	);
};

export default Home;
